module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5965deb09137398aa3c57d76d2f19587.png";